import {VeevaVeapApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const veevaVeapApi = new VeevaVeapApi(configuration);
export const requestVeevaVeap = (searchedTerm: string) => {
  return veevaVeapApi.getVeap({searchedTerm});
};

export const requestVeevaMdpList = (veevaId: string) => veevaVeapApi.getMDPList({id: veevaId});

export const requestVeevaDocMetadata = async (veapId: string) => {
  const basePath = configuration.basePath?.replace(/\/$/, '') || '';
  const requestUrl = `${basePath}/veeva/doc-metadata/${encodeURIComponent(veapId)}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    credentials: 'include',
  });

  if (response.status === 404) {
    // No document found for this VEAP — non-blocking, return null
    return null;
  }

  if (!response.ok) {
    throw response;
  }

  return response.json();
};

export const requestVeevaMdpModelLanguage = async (mdpUrl: string, knownValues: string[]) => {
  const query = new URLSearchParams();
  query.append('mdpUrl', mdpUrl);
  knownValues.forEach((value) => query.append('knownValues', value));

  const basePath = configuration.basePath?.replace(/\/$/, '') || '';
  const requestUrl = `${basePath}/veeva/mdp-model-language?${query.toString()}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw response;
  }

  return response.json();
};
